<div class="config-page">
  <div class="p-card config-card">
    <div class="config-card-header">
      <div class="config-search-bar">
        <span class="p-input-icon-left config-search-wrapper">
          <i class="pi pi-search"></i>
          <input
            #searchInput
            type="text"
            pInputText
            [(ngModel)]="search"
            (input)="onSearchInput()"
            placeholder="Search config keys, names, values..."
            class="config-search-input"
            autofocus
          >
        </span>
        <span class="config-count" *ngIf="!loading">
          {{ visibleCount }} / {{ totalCount }}
        </span>
        <button
          pButton
          type="button"
          icon="pi pi-plus"
          class="p-button-text p-button-sm"
          (click)="toggleAddCustom()"
          pTooltip="Add custom config"
          tooltipPosition="left"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-refresh"
          class="p-button-text p-button-sm"
          (click)="reload()"
          [loading]="loading"
          pTooltip="Reload"
          tooltipPosition="left"
        ></button>
      </div>

      <div *ngIf="showAddCustom" class="config-custom-row">
        <input
          type="text"
          pInputText
          [(ngModel)]="customKey"
          placeholder="config.key.name"
          class="config-custom-key"
        >
        <input
          type="text"
          pInputText
          [(ngModel)]="customValue"
          placeholder="value"
          class="config-custom-value"
        >
        <button
          pButton
          type="button"
          label="Save"
          icon="pi pi-check"
          class="p-button-sm"
          (click)="saveCustom()"
          [loading]="customSaving"
          [disabled]="!customKey.trim()"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-times"
          class="p-button-text p-button-sm"
          (click)="toggleAddCustom()"
        ></button>
      </div>
    </div>

    <div *ngIf="loading" class="config-loading">
      <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
      <span>Loading configuration...</span>
    </div>

    <div *ngIf="!loading" class="config-scroll">
      <table class="config-table">
        <thead>
          <tr>
            <th class="config-col-name">Name</th>
            <th class="config-col-value">Value</th>
            <th class="config-col-actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of filteredRows; trackBy: trackByKey"
            class="config-tr"
            [class.config-tr-dirty]="row.dirty"
            [class.config-tr-inherited]="row.isInherited"
            [class.config-tr-set]="row.isSetInZone"
          >
            <td class="config-td-name">
              <div
                class="config-name"
                role="button"
                tabindex="0"
                (click)="copyKey(row)"
                (keydown.enter)="copyKey(row)"
                (keydown.space)="copyKey(row)"
                title="Click to copy key"
              >
                {{ row.name }}
              </div>
              <div
                class="config-key"
                role="button"
                tabindex="0"
                (click)="copyKey(row)"
                (keydown.enter)="copyKey(row)"
                (keydown.space)="copyKey(row)"
                title="Click to copy key"
              >
                {{ row.key }}
              </div>
              <div class="config-desc" *ngIf="row.description">
                {{ row.description }}
              </div>
            </td>

            <td class="config-td-value">
              <div class="config-value-container">
                <div class="config-value-input-row">
                  <input
                    *ngIf="!isSecret(row) && row.format !== 'boolean'"
                    type="text"
                    pInputText
                    [(ngModel)]="row.value"
                    (ngModelChange)="onValueChange(row)"
                    [disabled]="row.readOnly"
                    class="config-value-input"
                    [placeholder]="row.hasValue ? '' : 'Not set'"
                  >
                  <select
                    *ngIf="row.format === 'boolean' && !isSecret(row)"
                    [(ngModel)]="row.value"
                    (ngModelChange)="onValueChange(row)"
                    [disabled]="row.readOnly"
                    class="config-value-select"
                  >
                    <option [ngValue]="null">Not set</option>
                    <option value="true">true</option>
                    <option value="false">false</option>
                  </select>
                  <div *ngIf="isSecret(row)" class="config-secret-row">
                    <span *ngIf="row.hasValue && !row.readOnly" class="config-secret-set">
                      <i class="pi pi-check-circle"></i> Value is set
                    </span>
                    <span *ngIf="row.hasValue && row.readOnly" class="config-secret-set">
                      <i class="pi pi-lock"></i> Value is set (read-only)
                    </span>
                    <span *ngIf="!row.hasValue && row.readOnly" class="config-secret-unset">
                      <i class="pi pi-lock"></i> Not set (read-only)
                    </span>
                    <input
                      *ngIf="!row.readOnly"
                      type="password"
                      pInputText
                      [(ngModel)]="row.value"
                      (ngModelChange)="onValueChange(row)"
                      class="config-value-input config-secret-input"
                      [placeholder]="row.hasValue ? 'Enter new value to replace' : 'Enter value to set'"
                    >
                  </div>
                </div>

                <div class="config-status-row">
                  <span
                    *ngIf="row.isSetInZone"
                    class="config-status config-status-set"
                    title="Value is set directly in this zone"
                  >
                    <i class="pi pi-check"></i> set in this zone
                  </span>
                  <span
                    *ngIf="row.isInherited"
                    class="config-status config-status-inherited"
                    title="Value is inherited from a parent zone"
                  >
                    <i class="pi pi-arrow-up"></i> inherited{{ row.fallbackZone ? ' from ' + row.fallbackZone : '' }}
                  </span>
                  <span
                    *ngIf="row.overridingZones.length > 0"
                    class="config-status config-status-override"
                    [pTooltip]="overridingZonesTooltip(row)"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-arrow-down"></i> {{ row.overridingZones.length }} child override{{ row.overridingZones.length > 1 ? 's' : '' }}
                  </span>
                  <span
                    *ngIf="!row.hasValue && !row.isInherited"
                    class="config-status config-status-unset"
                  >
                    not set
                  </span>
                  <span *ngIf="row.format !== 'string'" class="config-status config-status-format">{{ row.format }}</span>
                  <span *ngIf="isSecret(row)" class="config-status config-status-secret"><i class="pi pi-lock"></i></span>
                  <span *ngIf="row.readOnly" class="config-status config-status-readonly"><i class="pi pi-eye"></i></span>
                </div>
              </div>
            </td>

            <td class="config-td-actions">
              <button
                pButton
                type="button"
                icon="pi pi-copy"
                class="p-button-text p-button-sm config-action-btn"
                (click)="copyValue(row)"
                [disabled]="!row.hasValue || isSecret(row)"
                pTooltip="Copy value"
                tooltipPosition="left"
              ></button>
              <button
                pButton
                type="button"
                icon="pi pi-save"
                class="p-button-text p-button-sm config-action-btn"
                (click)="save(row)"
                [disabled]="!row.dirty || row.readOnly || row.saving"
                [loading]="row.saving"
                pTooltip="Save"
                tooltipPosition="left"
              ></button>
              <button
                *ngIf="row.isSetInZone"
                pButton
                type="button"
                icon="pi pi-undo"
                class="p-button-text p-button-sm config-action-btn"
                (click)="resetToParent(row)"
                [disabled]="row.saving"
                pTooltip="Reset to parent value"
                tooltipPosition="left"
              ></button>
              <button
                *ngIf="row.overridingZones.length > 0"
                pButton
                type="button"
                icon="pi pi-eraser"
                class="p-button-text p-button-sm config-action-btn"
                (click)="resetChildren(row)"
                [disabled]="row.saving"
                pTooltip="Reset all child overrides"
                tooltipPosition="left"
              ></button>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="!loading && filteredRows.length === 0" class="config-empty">
        <i class="pi pi-search"></i>
        <span>No configs found matching "{{ search }}"</span>
      </div>
    </div>
  </div>
</div>